const pageNameKey = "selectedItemsHiddenText";

export const selectedItemsHiddenTextEn = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate: "{count} selected items hidden",
    eyeLashButtonAltText: "Eye lash",
  },
};

export const selectedItemsHiddenTextPtBr = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate: "{count} itens selecionados ocultos",
    eyeLashButtonAltText: "Cílio",
  },
};

export const selectedItemsHiddenTextDe = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate:
      "{count} ausgewählte Elemente sind ausgeblendet",
    eyeLashButtonAltText: "Wimper",
  },
};

export const selectedItemsHiddenTextZhHans = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate: "{count} 个选定的项目已隐藏",
    eyeLashButtonAltText: "睫毛",
  },
};

export const selectedItemsHiddenTextIt = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate:
      "{count} elementi selezionati sono nascosti a causa del filtro",
    eyeLashButtonAltText: "Ciglia",
  },
};

export const selectedItemsHiddenTextEs = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    selectedHiddenItemsTemplate: "{count} elementos seleccionados ocultos",
    eyeLashButtonAltText: "Pestaña",
  },
};

export const selectedItemsHiddenTextNl = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    eyeLashButtonAltText: "Tabblad",
    selectedHiddenItemsTemplate: "{count} geselecteerde items verborgen",
  },
};

export const selectedItemsHiddenTextTr = {
  [pageNameKey]: {
    countPlaceholder: "{count}",
    eyeLashButtonAltText: "Kirpik",
    selectedHiddenItemsTemplate: "{count} seçilen öğeler gizlendi",
  },
};
